module.exports = __webpack_public_path__ + "static/media/17_plantilla_rec_combo_simple_cp_gaseosas_vidrio_350_spsa.8b8f655d.png";